import { pca } from "@features/auth/config/msalConfig.ts"
import { LocalStorageSession } from "@/shared"
import { showNotification } from "@mantine/notifications"
import { IHandleLogout } from "@features/auth/domain/auth.interfaces.ts"

export class MsalAuthService {
  /**
   * Retorna la instancia única de MSAL inicializada en msalConfig.ts
   * @returns The MSAL instance
   */
  static async getMsalInstance() {
    return pca
  }

  /**
   * @name handleLogout
   * @param config
   * @static
   * @description Función para cerrar sesión
   * @returns Promise<void>*/
  static async handleLogout(config: IHandleLogout): Promise<void> {
    const { instance, logout, logoutMutationAsync, isLocalLogout } = config

    try {
      // 1. Cerrar sesión del backend
      await logoutMutationAsync(null)

      // 2. Limpiar estado
      logout()

      // 3. Limpiar almacenamiento local
      await LocalStorageSession.clearSession()

      // 4. Cerrar sesión de MSAL si no es un cierre de sesión local
      if (!isLocalLogout) {
        await instance.logoutRedirect({ postLogoutRedirectUri: globalThis.location.origin + "/login" })
      } else {
        // Redirigir manualmente si es local
        globalThis.location.href = globalThis.location.origin + "/login"
      }

      showNotification({ title: "Éxito", message: "Cierre de sesión exitoso" })
    } catch (e) {
      console.log(e)
      showNotification({ title: "Error", message: "Error al cerrar sesión", color: "red" })
    }
  }
}
